module.exports = __webpack_public_path__ + "static/media/ak-hi-sm.4e99ff51.png";